// Other
import CONFIG from 'app.config';

import locationPinImg from '../../../../assets/images/maps/location-pin.png';
import blankBlueInstantImg from '../../../../assets/images/maps/pin-blank-blue-instant.png';
import blankBlueImg from '../../../../assets/images/maps/pin-blank-blue.png';
import blankCoralInstantImg from '../../../../assets/images/maps/pin-blank-coral-instant.png';
import blankCoralImg from '../../../../assets/images/maps/pin-blank-coral.png';
import blankWhiteBlueInstantImg from '../../../../assets/images/maps/pin-blank-white-blue-instant.png';
import blankWhiteBlue from '../../../../assets/images/maps/pin-blank-white-blue.png';
import blankWhiteCoralInstantImg from '../../../../assets/images/maps/pin-blank-white-coral-instant.png';
import blankWhiteCoral from '../../../../assets/images/maps/pin-blank-white-coral.png';
import dotBlueImg from '../../../../assets/images/maps/pin-blue-dotted.png';
import dotCoralImg from '../../../../assets/images/maps/pin-coral-dotted.png';

// TypeScript types for Google Maps objects (used in MapMarker component)
export interface MarkerIconConfig {
  url: string;
  scaledSize: { height: number; width: number; };
  anchor: { x: number; y: number; };
  labelOrigin: { x: number; y: number; };
}

interface InfoWindowOptions {
  disableAutoPan: boolean;
}

interface MapOptions {
  clickableIcons: boolean;
  fullscreenControl: boolean;
  mapTypeControl: boolean;
  scrollwheel: boolean;
  streetViewControl: boolean;
  maxZoom?: number;
}

// Exports
export const GOOGLE_SCRIPT_ID = 'googlePlaces';
export const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${
  CONFIG.GOOGLE_MAPS_API_KEY
}&v=3.exp&libraries=geometry,drawing,places&language=en`;

// Google Maps geocoding types for cities, neighborhoods, and local areas
// locality: city/town, sublocality: district/area within city, neighborhood: local neighborhood
export const PREFERRED_LOCATION_TYPES = ['locality', 'sublocality', 'neighborhood'];

// This is used in the SearchHere button to display "Search near _here_" as a fallback when the location name is not found.
export const LOCATION_FALLBACK = 'here';

export const INFO_WINDOW_OPTIONS: InfoWindowOptions = {
  disableAutoPan: true,
};

export const LOCATION_SEARCH_TRIGGER_NAMES: Record<string, string> = {
  MAP_MARKER_DRAG_END: 'map-marker-drag-end',
  MAP_SEARCH_HERE_BUTTON: 'map-search-here-button',
};

// CSS to hide Google Maps InfoWindow close button
export const GOOGLE_MAPS_CUSTOM_STYLES = `
  .gm-style-iw button[title="Close"] {
    display: none !important;
  }
  .gm-style-iw .gm-ui-hover-effect {
    display: none !important;
  }
`;

export const MAP_OPTIONS: MapOptions = {
  clickableIcons: false,
  fullscreenControl: false,
  mapTypeControl: false,
  scrollwheel: false,
  streetViewControl: false,
  maxZoom: 14,
};

export const MARKER_ICONS: Record<string, MarkerIconConfig> = {
  // userLocation: {
  //   url: userLocationImg,
  //   scaledSize: { height: 26, width: 26 },
  //   anchor: { x: 13, y: 13 },
  // },
  // clinicPin: {
  //   url: '/images/discovery/maps/pin-clinic.png',
  //   scaledSize: new google.maps.Size(40, 47),
  //   anchor: new google.maps.Point(20, 40)
  // },
  // dentistPin: {
  //   url: '/images/discovery/maps/pin-dentist.png',
  //   scaledSize: new google.maps.Size(40, 47),
  //   anchor: new google.maps.Point(20, 40)
  // },
  // blankTeal: {
  //   url: '/images/discovery/maps/pin-blank-teal.png',
  //   scaledSize: new google.maps.Size(46, 55),
  //   anchor: new google.maps.Point(23, 45),
  //   labelOrigin: new google.maps.Point(21, 23)
  // },
  // blankWhite: {
  //   url: '/images/discovery/maps/pin-blank-white.png',
  //   scaledSize: new google.maps.Size(46, 55),
  //   anchor: new google.maps.Point(23, 45),
  //   labelOrigin: new google.maps.Point(21, 23)
  // },
  locationPin: {
    url: locationPinImg,
    scaledSize: { height: 40, width: 32 },
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
  },
  blankCoral: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: blankCoralImg,
  },
  blankWhiteCoral: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: blankWhiteCoral,
  },
  coralDotted: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: dotCoralImg,
  },
  blankCoralInstant: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 12 },
    scaledSize: { height: 40, width: 30 },
    url: blankCoralInstantImg,
  },
  blankWhiteCoralInstant: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 12 },
    scaledSize: { height: 40, width: 30 },
    url: blankWhiteCoralInstantImg,
  },
  blankBlue: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: blankBlueImg,
  },
  blankWhiteBlue: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: blankWhiteBlue,
  },
  blueDotted: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 16 },
    scaledSize: { height: 40, width: 30 },
    url: dotBlueImg,
  },
  blankBlueInstant: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 12 },
    scaledSize: { height: 40, width: 30 },
    url: blankBlueInstantImg,
  },
  blankWhiteBlueInstant: {
    anchor: { x: 15, y: 40 },
    labelOrigin: { x: 15, y: 12 },
    scaledSize: { height: 40, width: 30 },
    url: blankWhiteBlueInstantImg,
  },
};
